<template>
  <div class="flex xs12 md12 x12">

    <va-card class="margin-b-1">
      <va-card-content>
        <a-breadcrumb>
          <a-breadcrumb-item>
            <router-link to="/admin/dashboard">Home / </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <router-link to="/admin/forum/forumindex">社区主页 / </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>版块主页</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="ant-row ant-row-middle">
          <a-select v-model:value="plateVal" label-in-value style="margin-right:20px;width:120px;"
                    @change="timeHandleChange" notFoundContent="暂无数据"
                    optionLabelProp="label"
                    placeholder="请选择选项"
                    :options="plateOption.map(item => ({ label: item.Name, value: item.ID ,IsTab:item.IsTab,Ord:item.Ord}))"
          >


          </a-select>
          <div style="margin-right:20px;" v-if="plateOption.length != 0">
            {{ plateVal.value == '' ? '全部板块' : plateVal.label }}
            <span>(
              <span style="margin-right:20px;">帖子:{{
                  plateVal.value == '' ? totalArticle : plateOption.filter(item => item.ID == plateVal.key)[0].ArticleCount
                }}</span>
              <span>回复:{{
                  plateVal.value == '' ? totalReply : plateOption.filter(item => item.ID == plateVal.key)[0].ReplyCount
                }}</span>)</span>
          </div>
          <router-link :to="{path:'/admin/forum/publishArticle'}" tag="a">
            <va-button class="flex xs14" :rounded="false" text-color="#ffffff" icon-left="search">发布帖子</va-button>
          </router-link>
        </div>
      </va-card-content>
      <va-card-content>
        <div class="row">
          <div class="flex xs12 plate-tabs">
            <div class="row flex xs12 md12 x12 ant-row-space-between">
              <div class="flex xs9 md9 x9">
                <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px;">
                  <template #tabs>
                    <va-tab @click="tabsCLick(item)" v-for="(item,index) in tabTitles" :name="item.Name" :key="index">
                      {{ item.Name }}
                    </va-tab>
                  </template>
                </va-tabs>
              </div>
              <div class="flex xs3 md3 x3 ant-row ant-row-middle posts-select" style="padding: 0;">
                <a-select v-model:value="timeValue" label-in-value :bordered="false" style="width:100px"
                          :options="timeOptions" @change="timeHandleChange">
                </a-select>
                <a-select v-model:value="updateValue" label-in-value :bordered="false" style="width:100px"
                          :options="updateOptions" @change="updateHandleChange">
                </a-select>
              </div>
            </div>
            <div style="padding:0 20px;">
              <postsList :pushdata="postslistdata" @postsRes="postsResData">
              </postsList>

            </div>
          </div>
        </div>
      </va-card-content>
    </va-card>
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue';
import {computed, defineComponent, ref, toRaw} from 'vue';
import postsList from './components/postsList.vue'
import postsMinxin from './postsMinxin.js';
import Qs from 'qs';

export default {
  name: 'postsPage',
  components: {postsList},
  data() {
    const tablePager = {
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    }
    return {
      postsResDataEmit: [],
      plateVal: ref({value: ''}), //选中板块名称
      plateOption: [], //版块基础数据
      timeOptions: [
        {value: '0', label: '全部时间',},
        {value: '1', label: '今天',},
        {value: '2', label: '三天内',},
        {value: '3', label: '一周内',},
        {value: '4', label: '一月内',},
        {value: '5', label: '半年内',}],
      updateOptions: [
        {value: '0', label: '最近更新',},
        {value: '1', label: '最新发布',},
        {value: '2', label: '点赞数',},
        {value: '3', label: '回复数',}],
      timeValue: ref({value: '0'}),
      updateValue: ref({value: '0'}),
      tabTitles: [],//Tab基础数据
      tabValue: '全部标签',//选种标签名称
      tabID: '',//选种标签ID
      postslistdata: [],
      totalReply: 0,
      totalArticle: 0,
      prevHref: '',
      tablePager
    }
  },
  computed: {
    computedStyle() {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 vm 访问组件实例,将值传入fromPath
      vm.fromPath = from.path;
      // console.log(to)
      vm.prevHref = from.path;
    });
  },
  mounted() {
    this.$nextTick(function () {

      this.getForumSection()
      this.getForumLabel();
      //根据上传访问的板块和标签绑定数据

      console.log('load forumPageData postsPage ')
      console.log(this.$store.state.forumPageData)
      //debugger
      let queryParse = this.$store.state.forumPageData;
      this.plateVal.value = queryParse.sectionID;
      this.plateVal.label = queryParse.sectionName;
      this.plateVal.key = queryParse.sectionID;
      this.tabValue = queryParse.labelName;
      this.tabID = queryParse.labelID;
      this.tablePager.currentPage = queryParse.pageIndex;
      this.tablePager.pageSize = queryParse.pageSize;
      this.timeValue.value = queryParse.TimeSpan;
      this.updateValue.value = queryParse.Order;
      console.log('queryParse')
      console.log(Qs.stringify(queryParse))

      this.searchClick()


    })

  },
  methods: {
    postsResData(param) {
      this.postsResDataEmit = param;
    },
    //查询帖子
    searchClick() {
      let that = this, paramsData;

      // let tabVal = this.tabTitles.filter(item => {
      //   return item.Name == that.tabValue;
      // })
      // console.log('取会标签值：' + that.tabValue)
      // console.log(tabVal)
      console.log(this.tabTitles)
      paramsData = {
        "SectionID": this.plateVal.value,//版块ID
        "SectionName": this.plateVal.label,//版块ID
        "Label": this.tabID === 7 ? '' : this.tabID, //标签ID，用‘,’隔开; ID 为7 表示是精华区
        "labelName": this.tabValue,
        "KeyWord": '', //查询关键字，标题或内容
        "Category": '', //类别ID
        "isshow": '1',
        "IsElite": this.tabID === 7 ? '1' : '', //1 精华；空或其他，全部 ；标签ID为7 表示是精华区
        "Creator": '', //发布人UID
        "TimeSpan": this.timeValue.value === undefined ? '0' : this.timeValue.value, //0 今天 1 三天内 2 一周内 3 一月内 4 半年内
        "Order": this.updateValue.value === undefined ? '0' : this.updateValue.value, //0 最近更新 1 最新发布 2 点赞数 3 回复数
        "currentPage": this.tablePager.currentPage, //当前页
        "pageSize": this.tablePager.pageSize//页大小
      };
      console.log(paramsData)
      //触发页面刷新
      this.postslistdata = paramsData;

      // postsRouterData = {//存储请求的数据与select的原始值
      //   'requestParam': {...paramsData},//请求的数据
      //   'plateVal': {...this.plateVal},//选择的板块值
      //   'tabValue': this.tabValue,//选择的tab标签值
      //   'timeValue': {...this.timeValue},//选择筛选时间的值
      //   'updateValue': {...this.updateValue}//选择条件的值
      // }
      // this.$store.commit('updatePostsRouterParam', JSON.stringify(postsRouterData))//记录筛选的条件


    },
    getForumSection(paramData) {
      let resData, totalArticle = 0, totalReply = 0;
      const params = {
        "Name": "",
      };
      this.$api.formsAPI.getForumSection(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
              return;
            }
            let arr = [{value: '', Name: '全部版块', IsTab: '', ID: '', Ord: 0}];
            resData = res.data.Data;
            resData.map((item, index) => {
              // console.log(item.ArticleCount)
              totalArticle += Number(item.ArticleCount);
              totalReply += Number(item.ReplyCount);
            })
            // resData.sort(this.compare('Ord'))
            this.plateOption = [...arr, ...resData];
            this.totalArticle = totalArticle;
            this.totalReply = totalReply;
            console.log(this.plateOption)

          })
          .catch(error => {
            console.log(error);
          })
    },
    compare(p) { //这是比较函数
      return function (m, n) {
        let a = m[p];
        let b = n[p];
        return a - b; //升序
      }
    },
    //获取tab
    getForumLabel() {

      let params = {
        "Name": "",
        "IsTab": "1"
      }, resData;
      this.$api.formsAPI.getForumLabel(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
              return;
            }
            let arr = [{"ID": "", "Name": "全部标签", "IsTab": "1", "Ord": ""}];
            resData = res.data.Data;
            this.tabTitles = [...arr, ...resData];
            console.log('加载了标签吗')
            console.log(this.tabTitles)
          })
          .catch(error => {
            console.log(error);
          })
    },
    updateHandleChange(value) {//选择更新时间
      // console.log(value)
      this.searchClick()
    },
    timeHandleChange(value) {//选择时间范围
      // console.log(value)
      this.searchClick()
    },
    tabsCLick(tab) {//选择tabs
      // console.log(this.tabValue)
      this.tabValue = tab.Name;
      this.tabID = tab.ID;
      this.searchClick()
    },
  }
}
</script>
<style src="./css/antd.css"></style>
<style>
.posts-select .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 !important;
}

.posts-select .ant-select {
  flex-basis: 50%;
  flex-grow: 0;
  max-width: 50%;
}
</style>
<style scoped>

.plate-tabs .va-tabs__tabs > div:nth-of-type(2) {

  font-size: 16px !important;
  margin-right: 20px;
}

.custom-breadcrumb .ant-breadcrumb-separator {
  color: #999;
  margin: 0 8px;
}
</style>
